import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { FileSpreadsheet } from "lucide-react"

const COLUMNS = [
  "MC_TPL_PREVIEW_COL_ARTICLE_NO",
  "MC_TPL_PREVIEW_COL_DESCRIPTION",
  "MC_TPL_PREVIEW_COL_SVHC",
  "MC_TPL_PREVIEW_COL_CONC",
] as const

// Abstract placeholder rows — the article scope is not org-specific here.
const ROWS = [0, 1, 2]

/**
 * Preview of the Excel workbook an inquiry attaches: the articles to fill
 * in, and nothing of the org's branding (no logo, footer or signature).
 * `compact` is the chip shown under the declaration PDF of a PDF + Excel
 * inquiry, which attaches both.
 */
export function WorkbookPreview({ compact = false }: { compact?: boolean }) {
  const { translate } = useTranslation()
  const title = (
    <div className="flex items-center gap-2 text-[12px] font-medium text-[#1d6f42]">
      <FileSpreadsheet className="size-4" aria-hidden />
      {translate("SETTINGS/PREVIEW/WORKBOOK")}
    </div>
  )
  if (compact)
    return (
      <div className="rounded-lg bg-white px-4 py-2.5 shadow-lg">{title}</div>
    )

  return (
    <div className="flex flex-col gap-3 rounded-lg bg-white px-5 py-4 shadow-lg">
      {title}
      <table className="w-full border-collapse text-[11px] text-[#222]">
        <thead>
          <tr className="bg-[#e7f1ea] text-left">
            {COLUMNS.map((key) => (
              <th key={key} className="border border-[#c9d9ce] px-2 py-1.5">
                {translate(key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ROWS.map((row) => (
            <tr key={row}>
              {COLUMNS.map((key) => (
                <td key={key} className="border border-[#d9e3dc] px-2 py-1.5">
                  <span className="block h-2 w-10 rounded bg-[#ededed]" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
